module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48dGl0bGU+bW9yZS12ZXJ0aWNhbDwvdGl0bGU+PHBhdGggZD0iTTEyIDBoOHY4aC04ek0xMiAxMmg4djhoLTh6TTEyIDI0aDh2OGgtOHoiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/gel-icon-more-vertical.svg
// module id = dAFa
// module chunks = 1